<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--step-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head l-main-head--sub">
          <div class="c-title">
            <div class="c-title__text c-title__text--blue u-fs34">
              配信済みシナリオの確認
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit-confirm">
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  シナリオ名
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ scenario.scenario_name }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  プッシュ対象
                </div>
                <div class="c-tag">
                  <ul class="c-tag-list">
                    <li
                      class="c-tag-list__item c-tag-list__item--green"
                    >
                      ブラウザ
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-head l-main-head--sub"></div>
        <div class="l-main-content">
          <div
            class="p-message-edit-confirm p-message-edit-confirm--details"
          >
            <div class="c-title">
              <div class="c-title__text u-fs24">
                配信条件
              </div>
            </div>
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">
                  配信条件
                </div>
                <div class="p-message-edit-confirm__text">
                  {{ getConditionString() }}
                </div>
              </div>
              <template v-if="hasMessageCondition()">
                <div
                  v-for="(messageCondition, loopIndex1) in firstMessage.message_conditions"
                  :key="loopIndex1"
                  class="p-message-edit-confirm-list__item"
                >
                  <div class="p-message-edit-confirm__title">
                    セグメント条件
                  </div>
                  <ul
                    class="p-message-edit-confirm-segment-list"
                  >
                    <li
                      class="p-message-edit-confirm-segment-list__item"
                    >
                      選択：{{
                        getConditionJoinTypeString(
                          messageCondition.condition
                        )
                      }}
                      条件
                    </li>
                    <li
                      class="p-message-edit-confirm-segment-list__item"
                    >
                      {{
                        getConditionTypeString(
                          messageCondition.condition
                        )
                      }}
                    </li>
                    <li
                      v-for="(conditionDetail, loopIndex2) in getConditionDetails(
                        messageCondition.condition
                      )"
                      :key="loopIndex2"
                      class="p-message-edit-confirm-segment-list__item"
                    >
                      {{
                        stepInfo.conditionOperatorTypes[
                          conditionDetail
                            .condition_operation
                        ]
                      }}
                      /
                      {{
                        getDescription(conditionDetail)
                      }}
                    </li>
                  </ul>
                </div>
              </template>
              <div
                v-if="hasTopicMessageCondition()"
                class="p-message-edit-confirm-list__item"
              >
                <div class="p-message-edit-confirm__title">
                  セグメント条件
                </div>
                <ul class="p-message-edit-confirm-segment-list">
                  <li
                    v-for="(topicConditionDetail, loopIndex3) in getTopicConditionDetails()"
                    :key="loopIndex3"
                    class="p-message-edit-confirm-segment-list__item"
                  >
                    {{
                      getTopicConditionDetailTypeString(
                        topicConditionDetail
                      )
                    }}
                    :
                    {{
                      getTopicConditionDetailValueString(
                        topicConditionDetail
                      )
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-head l-main-head--sub">
          <div class="c-title">
            <h3 class="c-title__text c-title__text--blue u-fs26">
              メッセージとトリガー設定
            </h3>
          </div>
        </div>

        <template v-for="(scenarioMessage, loopIndex4) in scenario.scenario_messages" :key="loopIndex4">
          <div
            v-if="scenarioMessage.step_no > 1"
            class="l-main-head l-main-head--connector"
          >
            <div class="c-icon-circle c-icon-circle--blue-2 u-wh80">
              <div
                class="c-icon-circle__item c-icon-circle__item--white c-icon-circle__item--stroke-white u-wh64"
              >
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use
                    xlink:href="/assets/img/sprite.svg#arrow-line-down"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div
            v-if="scenarioMessage.step_no > 1"
            class="l-main-content"
          >
            <div
              class="p-message-edit-confirm p-message-edit-confirm--details"
            >
              <div class="c-title">
                <div class="c-title__text u-fs24">
                  {{
                    scenarioMessage.step_no
                  }}通目へのトリガー設定
                </div>
              </div>
              <div class="p-step-trigger">
                <div class="p-step-trigger__row">
                  <div
                    class="p-step-trigger__text p-step-trigger__text--action"
                  >
                    {{
                      getDeliverTargetString(
                        scenarioMessage.deliver_target
                      )
                    }}
                  </div>
                </div>
                <div class="p-step-trigger__row">
                  <div class="p-step-trigger__text">
                    に対して
                  </div>
                </div>
                <div class="p-step-trigger__row">
                  <div
                    class="p-step-trigger__text p-step-trigger__text--date"
                  >
                    {{
                      getSpanDay(scenarioMessage.step_no)
                    }}日後
                  </div>
                  <div class="p-step-trigger__text">の</div>
                  <div
                    class="p-step-trigger__text p-step-trigger__text--time"
                  >
                    {{
                      getSpanTimeString(
                        scenarioMessage.step_no
                      )
                    }}
                  </div>
                  <div class="p-step-trigger__text">
                    に{{
                      scenarioMessage.step_no
                    }}通目のメッセージを配信する
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="scenarioMessage.step_no > 1"
            class="l-main-head l-main-head--connector"
          >
            <div class="c-icon-circle c-icon-circle--blue-2 u-wh80">
              <div
                class="c-icon-circle__item c-icon-circle__item--white c-icon-circle__item--stroke-white u-wh64"
              >
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use
                    xlink:href="/assets/img/sprite.svg#arrow-line-down"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="l-main-content">
            <div
              class="p-message-edit-confirm p-message-edit-confirm--preview"
            >
              <div class="c-title c-title--left">
                <div class="c-title__text u-fs24">配信内容</div>
                <div class="c-text u-fs--s">
                  実際の配信メッセージと表示が異なることがあります
                </div>
              </div>
              <div class="p-message-preview-list">
                <div class="p-message-preview-list__block">
                  <div class="p-message-preview__title">
                    <div class="c-text u-text-bold">
                      PCでの配信例
                    </div>
                  </div>
                  <!-- プレビュー: PC -->
                  <message-preview
                    :title="
                      scenarioMessage.message
                        .message_title
                    "
                    :text="
                      scenarioMessage.message.message_text
                    "
                    :url="scenarioMessage.message.click_url"
                    :icon-url="
                      scenarioMessage.message.image_url
                    "
                    :large-image-url="
                      scenarioMessage.message
                        .large_image_url
                    "
                    :has-button-a="
                      scenarioMessage.message
                        .action_button_text_a != null
                    "
                    :has-button-b="
                      scenarioMessage.message
                        .action_button_text_b != null
                    "
                    :action-button-text-a="
                      scenarioMessage.message
                        .action_button_text_a
                    "
                    :action-button-text-b="
                      scenarioMessage.message
                        .action_button_text_b
                    "
                  />
                </div>
                <div class="p-message-preview-list__block">
                  <div class="p-message-preview__title">
                    <div class="c-text u-text-bold">
                      スマホでの配信例
                    </div>
                  </div>
                  <message-preview-sp
                    :title="
                      scenarioMessage.message
                        .message_title
                    "
                    :text="
                      scenarioMessage.message.message_text
                    "
                    :url="scenarioMessage.message.click_url"
                    :icon-url="
                      scenarioMessage.message.image_url
                    "
                    :large-image-url="
                      scenarioMessage.message
                        .large_image_url
                    "
                    :has-button-a="
                      scenarioMessage.message
                        .action_button_text_a != null
                    "
                    :has-button-b="
                      scenarioMessage.message
                        .action_button_text_b != null
                    "
                    :action-button-text-a="
                      scenarioMessage.message
                        .action_button_text_a
                    "
                    :action-button-text-b="
                      scenarioMessage.message
                        .action_button_text_b
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </main>
    </div>
    <div class="p-message-predict">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend"></div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--gray u-w320 u-h50 u-fs20"
            type="button"
            name="prev"
            value="prev"
            @click="onBackClick()"
          >
            <p v-if="page == 'step'" class="c-btn__text">
              シナリオ配信の一覧に戻る
            </p>
            <p v-else class="c-btn__text">
              配信メッセージの一覧に戻る
            </p>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    stepInfo: Object,
    csrfToken: String,
    breadcrumbData: Array,
    scenario: Object,
  },
  data() {
    return {
      page: location.pathname.endsWith('/step/review')
        ? 'step'
        : 'message',
    };
  },
  computed: {
    firstMessage: function () {
      let message = null;
      if (this.scenario && this.scenario.scenario_messages.length > 0) {
        message = this.scenario.scenario_messages[0].message;
      }
      return message;
    },
  },
  mounted: function () {},
  methods: {
    onBackClick: function () {
      location.href = `/coins-admin/${this.page}`;
    },
    getConditionString: function () {
      let conditionString;
      if (this.firstMessage.topic_flag == 1) {
        // ALL
        conditionString = '全配信';
      } else {
        conditionString = 'セグメント配信';
      }

      return conditionString;
    },
    hasMessageCondition: function () {
      return (
        this.firstMessage.message_conditions &&
        this.firstMessage.message_conditions.length > 0
      );
    },
    hasTopicMessageCondition: function () {
      return this.firstMessage.topic_message_condition;
    },
    getCondition: function () {
      let condition = null;
      if (
        this.firstMessage.message_conditions &&
        this.firstMessage.message_conditions.length > 0
      ) {
        let messageCondition = this.firstMessage.message_conditions[0];
        if (messageCondition.condition) {
          condition = messageCondition.condition;
        }
      }
      return condition;
    },
    getConditionDetails: function (condition) {
      let conditionDetails = [];
      if (condition) {
        conditionDetails = condition.condition_details;
      }
      return conditionDetails;
    },
    getSpanDay: function (stepNo) {
      let spanDay = 0;
      if (stepNo > 1) {
        let previousDate =
          this.scenario.scenario_messages[stepNo - 2].message
            .message_deliver.send_start_date;
        let currentDate =
          this.scenario.scenario_messages[stepNo - 1].message
            .message_deliver.send_start_date;

        let dateFrom = moment(previousDate.substring(0, 10));
        let dateTo = moment(currentDate.substring(0, 10));
        spanDay = dateTo.diff(dateFrom, 'days');
        if (spanDay < 0) spanDay = 0;
      }
      return spanDay;
    },
    getSpanTimeString: function (stepNo) {
      let spanTimeString;
      let currentDate =
        this.scenario.scenario_messages[stepNo - 1].message
          .message_deliver.send_start_date;
      spanTimeString = moment(currentDate).format('H時mm分');
      return spanTimeString;
    },
    getDeliverTargetString: function (deliverTarget) {
      return this.stepInfo.deliverTargetTypes[deliverTarget];
    },
    getConditionJoinTypeString: function (condition) {
      let conditionJoinTypeString = '';
      //let condition = this.getCondition();
      if (condition) {
        conditionJoinTypeString = condition.condition_join_type;
      }
      return conditionJoinTypeString;
    },
    getConditionTypeString: function (condition) {
      let conditionTypeString = '';
      //let condition = this.getCondition();
      if (condition) {
        let conditionDetails = condition.condition_details;
        if (conditionDetails && conditionDetails.length > 0) {
          let conditionKey = conditionDetails[0].condition_key;
          conditionTypeString =
            this.stepInfo.conditionKeyTypes[conditionKey] +
            '：' +
            this.stepInfo.conditionKeyExplanations[conditionKey];
        }
      }
      return conditionTypeString;
    },
    getDescription: function (conditionDetail) {
      // 変換が必要なければvalueそのまま
      let description = conditionDetail.condition_value;
      if (
        this.stepInfo.conditionKeyOptions[conditionDetail.condition_key]
      ) {
        let options =
          this.stepInfo.conditionKeyOptions[
            conditionDetail.condition_key
          ];

        if (options[conditionDetail.condition_value]) {
          // 変換が必要なら変換した値
          description = options[conditionDetail.condition_value];
        }
      }
      return description;
    },
    getTopicConditionDetails: function () {
      let topicConditionDetails = [];
      if (this.firstMessage.topic_message_condition) {
        let topicMessageCondition =
          this.firstMessage.topic_message_condition;
        if (topicMessageCondition.topic_condition) {
          topicConditionDetails =
            topicMessageCondition.topic_condition
              .topic_condition_details;
        }
      }
      return topicConditionDetails;
    },
  },
};
</script>
